"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Keyboard {
    constructor() {
        /**
         * @property {boolean} candidate - Feature to enable/disable candidate field
         * true: to enable candidate field, false: to disable candidate field
         */
        this.candidate = false;
        /**
         * @property {String} comment - Comment field. Max characters is 128
         */
        this.comment = '';
        /**
         * @property {String} title - Title field. Max characters is 128.
         */
        this.title = '';
        /**
         * @property {String} placeholder - Placeholder field. Max characters is 128.
         */
        this.placeholder = '';
        /**
         * @property {String} titleStyle - Attribute of tile style "normal" is gray color
         * "error" is red color.
         */
        this.titleStyle = 'normal';
        /**
         * @property {String} type - Input type "text", "email", "password".
         */
        this.type = 'text';
        /**
         * @property {String} value - Value of Keyboard.
         */
        this.value = '';
        try {
            this.keyboardWrapper = new ToyotaKeyboard();
        }
        catch {
            throw Error('Unavible to launch the keyboard');
        }
    }
    /**
     * @function show Will call native keyboard
     * @Return void
     */
    show() {
        this.keyboardWrapper.show();
    }
    /**
     * @function close Will close native keyboard
     * @Return void
     */
    close() {
        this.keyboardWrapper.close();
    }
    /**
     * @function getProp Will get one of the property value of native keyboard
     * @param prop Name of the property
     * @Return candidate, comment, title, placeholder, titleStyle, type, value
     */
    getProp(prop) {
        return this.keyboardWrapper[prop];
    }
    /**
     * @function setProp Will set one of the property value of native keyboard
     * @param prop Name of the property
     * @param datum Value of the property to be set
     * @Return candidate, comment, title, placeholder, titleStyle, type, value
     */
    setProp(prop, datum) {
        this.keyboardWrapper[prop] = datum;
    }
    /**
     * @property onclose Will call the callback passed if the ToyotaKeyboard is close
     * @param callback Callback function on the client side
     * @Return void
     */
    set onclose(callback) {
        this.keyboardWrapper.onclose = callback;
    }
    /**
     * @property onchange Will call the callback passed if the ToyotaKeyboard is changing value
     * @param callback Callback function on the client side
     * @Return void
     */
    set onchange(callback) {
        this.keyboardWrapper.onchange = callback;
    }
    /**
     * @property oninput Will call the callback passed if the ToyotaKeyboard is setting a value
     * @param callback Callback function on the client side
     * @Return void
     */
    set oninput(callback) {
        this.keyboardWrapper.oninput = callback;
    }
    /**
     * @property oncancel Will call the callback passed if the
     * ToyotaKeyboard is closig or hitting  hidding.
     * @param callback Callback function on the client side
     * @Return void
     */
    set oncancel(callback) {
        this.keyboardWrapper.oncancel = callback;
    }
    /**
     * @property onerror Will call the callback passed if the
     * ToyotaKeyboard failing when calling any of the other property event handlers.
     * @param callback Callback function on the client side
     * @Return void
     */
    set onerror(callback) {
        this.keyboardWrapper.onerror = callback;
    }
    /**
     * @property onfocus Will call the callback passed if the
     * ToyotaKeyboard is having the focus on the typing area.
     * @param callback Callback function on the client side
     * @Return void
     */
    set onfocus(callback) {
        this.keyboardWrapper.onfocus = callback;
    }
    /**
     * @property onblur Will call the callback passed if the
     * ToyotaKeyboard lose the focus on the typing area.
     * @param callback Callback function on the client side
     * @Return void
     */
    set onblur(callback) {
        this.keyboardWrapper.onblur = callback;
    }
}
exports.default = Keyboard;
//# sourceMappingURL=Keyboard.js.map